import { render } from "./TooltipsItem.vue?vue&type=template&id=7965931e"
import script from "./TooltipsItem.vue?vue&type=script&lang=js"
export * from "./TooltipsItem.vue?vue&type=script&lang=js"

import "./TooltipsItem.vue?vue&type=style&index=0&id=7965931e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__